import { setTimeoutWithDestroyRef } from 'src/app/core/utils/lifecycle-timeout';
import { AfterViewInit, Component, Input, OnDestroy, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, timer , Subject, takeUntil} from 'rxjs';
import { take } from 'rxjs/operators';
import { BroadcastService, HttpService, LocalStorageService, MessageService, PermissionService, UserService } from 'src/app/core';
import { MsgConstantConfig } from 'src/app/core/config/message.constant.config';
import { PathConfig } from 'src/app/core/config/path.config';
import { UserInfo } from 'src/app/core/models/user/user-info.model';
import { ClientDetailService } from 'src/app/core/services/client-detail-service';
import { ClientUtils } from 'src/app/core/utils/clientUtil';
import { Utility } from 'src/app/core/utils/utility';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-re-login',
  templateUrl: './re-login.component.html',
  styleUrls: ['./re-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReLoginComponent implements AfterViewInit,OnDestroy {
  private readonly destroy$ = new Subject<void>();

  private readonly destroyRef = inject(DestroyRef);

  @Input() isMaintenance:number=0;
  @Input() set prefillEmail(email: string) {
    this.prefillEmailValue = email;
    this.applyEmail(email);
  }
  loginForm!: UntypedFormGroup;
  isRemembered:boolean = false;
  eventSubscription:Array<Subscription> = [];
  submitted = false;
  loginUrl: string = environment.LOGIN_URL;
  userEmail:string = '';
  maintenance: any = 0;
  is2FAEnable:boolean = false;
  twoFAForm!: UntypedFormGroup;
  countDown:any = new Subscription();
  counter: number = 60;
  iscountDown: boolean = false;
  authData:any;
  config:any;
  clientId:string='';
  mobileSubscriptionOTP:any;
  canEditSensitiveInformation:boolean=true;
  loginAsClientPrefix = '';
  isLoginAsClient:boolean = false;
  confirmationId:any;
  private prefillEmailValue = '';
  constructor(
    private httpService:HttpService,
    private msgService:MessageService,
    private userService:UserService,
    private clientDetailService:ClientDetailService,
    private activeModal: NgbActiveModal,
    private broadCastService:BroadcastService,
    private activatedRoute:ActivatedRoute,
    private route:Router,
    private translateService:TranslateService,
    private sanitizer: DomSanitizer,
    private permissionService:PermissionService,
    private localStorageService:LocalStorageService
  ) {
    this.config = Utility.getOTPConfig();
    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('Selected_Language') || 'en');

    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required,Validators.email]),
      password: new UntypedFormControl('', [Validators.required])
    });
    //two FA form controls
    this.twoFAForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required,Validators.email]),
      code : new UntypedFormControl('', [Validators.required])
    });
    this.loginAsClientPrefix = Utility.getLoginAsClientUserPrefix();
    this.isLoginAsClient = ClientUtils.isLoginAsClient(this.clientDetailService, this.userService);
    this.applyEmail(this.userService.getSessionEmail());
  }

  ngAfterViewInit(): void {
    this.canEditSensitiveInformation=this.permissionService.isSpecialPermission('can_edit_sensitive_information');
    this.clientId = this.activatedRoute.snapshot.firstChild?.params['clientId'] || this.clientDetailService.CLIENT_ID;
    this.applyEmail(this.prefillEmailValue || this.userService.getSessionEmail());
    this.getMaintenanceStatus();
    if(this.isMaintenance) {
      this.maintenance = 1;
    }
    this.broadCastService.on(MsgConstantConfig.MAINTENANCE).pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.clientDetailService.hasActiveHighAlert()) {
        return;
      }
      this.maintenance = 1;
    });
  }
  
  getMaintenanceStatus(){
    if (this.clientDetailService.hasActiveHighAlert()) {
      this.maintenance = 0;
      return;
    }
    this.maintenance=this.clientDetailService.getClientInfo('maintenance_flag')||0;
  }

  private applyEmail(email?: string): void {
    const value = email || this.userService.getSessionEmail();
    if (!value || !this.loginForm) {
      return;
    }
    this.userEmail = value;
    this.loginForm.patchValue({ email: value });
  }

  //submit form
  onSubmit(event:any):void {

    this.loginForm.markAllAsTouched();
    if(this.loginForm.valid && !this.submitted) {
      this.submitted = true;
      const loginCredentials = {...this.loginForm.value};
      this.userService.setSessionEmail(loginCredentials.email);
      if(ClientUtils.isLoginAsClient(this.clientDetailService, this.userService)){
        loginCredentials.email = `${this.loginAsClientPrefix}${loginCredentials.email}`;
      }
      loginCredentials.is_client  = this.clientDetailService.getClientInfo('is_default') == 'YES' ? 'NO' : 'YES';
      this.httpService.post(PathConfig.AUTH_LOGIN_LOGOUT,loginCredentials).subscribe((response)=>{
        this.authData = response;
        this.confirmationId = response?.confirmation_id;
        if(this.authData?.auth_data?.QRcode){
          this.authData.auth_data.QRcode=this.sanitizer.bypassSecurityTrustHtml(this.authData.auth_data.QRcode);
        }
        if('user' in response && 'enable_2fa' in response.user && response?.user?.enable_2fa=='YES'){
          this.is2FAEnable = true;
          // this.twoFAForm.patchValue({email:response?.user?.email});
          this.twoFAForm.patchValue({email:loginCredentials?.email});
          this.authData?.user?.mfa_type !== 'APP' && this.otpTimer();
          this.submitted = false;
        }else{
          this.msgService.showSuccess('Logged In successfully.')
          this.userService.setAuthToken(response.access_token);
          this.userService.setAuthTokenExpiry(response.token_expiry);
          this.userService.setUserInfo(new UserInfo(response.user));
          const clientId = this.activatedRoute.snapshot.firstChild?.params['clientId'];
          if(clientId){
            this.userService.setPermissions(clientId,response.permissions);
          }
          this.broadCastService.broadcast(MsgConstantConfig.USER_LOGGED_IN);

          //if email not found redirect to dashboard
          if(!this.userEmail){
            this.route.navigate([clientId+'/landing']);
          }
          this.submitted = false;
          this.activeModal.close(true);
          window.location.reload();
        }
      },(err)=>{
        if(err.error.message){
          this.msgService.showError(err.error.message);
        }
        this.submitted = false;
      })

    }
  }

  on2FASubmit(event:any):void {
    this.twoFAForm.markAllAsTouched();
    if(this.twoFAForm.valid && !this.submitted) {
      this.submitted = true;
      const loginCredentials = this.twoFAForm.value;
      loginCredentials.is_client  = this.clientDetailService.getClientInfo('is_default') == 'YES' ? 'NO' : 'YES';
      loginCredentials.confirmation_id = this.confirmationId;
      this.httpService.post(PathConfig.AUTH_2FA_VERIFICATION,loginCredentials).subscribe((response)=>{
          this.msgService.showSuccess('Logged In successfully.')
          this.userService.setAuthToken(response.access_token);
          this.userService.setAuthTokenExpiry(response.token_expiry);
          this.userService.setUserInfo(new UserInfo(response.user));
          const clientId = this.activatedRoute.snapshot.firstChild?.params['clientId'];
          if(clientId){
            this.userService.setPermissions(clientId,response.permissions);
          }
          this.broadCastService.broadcast(MsgConstantConfig.USER_LOGGED_IN);
          //if email not found redirect to dashboard
          if(!this.userEmail){
            this.route.navigate([clientId+'/landing']);
          }
          this.submitted = false;
          this.activeModal.close(true);
          window.location.reload();
      },(err)=>{
        if(err.error.message){
          this.msgService.showError(err.error.message);
        }
        this.submitted = false;
      })

    }
  }

  onResendCode(from?:any) {
    if(from){
      const param = {
        firstname: this.authData?.user?.firstname,
        lastname: this.authData?.user?.lastname,
        user_id: this.authData?.user?.id,
      };
      this.httpService.put(PathConfig.VERIFY_MOBILE_NUMBER,param).subscribe((response) => {
        this.counter = 60;
        this.otpTimer();
      }, (err) => {
        if (err?.error?.message) {
          this.msgService.showError(err.error.message);
        }
        this.submitted = false;
      });
      } else{
    this.httpService.post(PathConfig.AUTH_2FA_RESEND_CODE,{email:this.twoFAForm.value.email}).subscribe((response)=>{
        this.msgService.showSuccess('Verification code re-send successfully.');   
        this.otpTimer();   
    },(err)=>{
      if(err?.error?.message){
        this.msgService.showError(err.error.message);
      }
      this.submitted = false;
    });
    }
  }

  refresh(){
    window.location.reload();
  }

  ngOnDestroy():void{
    this.destroy$.next();
    this.destroy$.complete();
    if (this.countDown) { this.countDown.unsubscribe();  }
  }

  otpTimer() {
    this.iscountDown = true;
    this.countDown = timer(0, 1000)
      .pipe(take(this.counter))
      .subscribe(() => {
        --this.counter;
        if (this.counter == 0) {
          this.counter = 60;
          this.iscountDown = false;
          this.countDown.unsubscribe();
        }
      });
  }

  onOtpChange(value: string) {
    this.mobileSubscriptionOTP = value;
  }

  verifySubscribedMobileCode(){
    const param = {
      pin: this.mobileSubscriptionOTP,
      user_id: this.authData?.user?.id
    };
    this.httpService.put(PathConfig.CONFIRM_VBT, param)
      .subscribe((response) => {
        this.msgService.showSuccess(response?.message);
        this.authData?.auth_data?.opt_in_status
        if(this.authData?.auth_data){
         this.authData.auth_data['opt_in_status']='SUBSCRIBED';
         this.countDown?.unsubscribe();
         this.counter = 60;
         this.otpTimer();
        }
      }, (err) => {
        this.msgService.showError(err.error.message);
      });
  }

  forgotPassword(){
    this.activeModal.close(true);
    this.localStorageService.removeClientInfo(this.clientId);
    this.route.navigate([this.clientId + '/forgot'],{state:{email:!this.userEmail?.includes('*') ? this.userEmail : null}});
  }
}
